(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }

  function initMobileATC() {
    var bar = document.querySelector('[data-ldo-mobile-atc]');
    var original = document.querySelector('.product-template-section .btn--add-to-cart');
    if (!bar || !original) return;

    var button = bar.querySelector('[data-ldo-mobile-atc-button]');
    var price = bar.querySelector('[data-ldo-mobile-atc-price]');
    var originalPrice = document.querySelector('.product-template-section [data-price] .h1');
    var originalText = original.querySelector('[id^="addToCartText-"]');

    function sync() {
      if (price && originalPrice) price.textContent = originalPrice.textContent.trim();
      if (button && originalText) button.textContent = originalText.textContent.trim();
      if (button) button.disabled = !!original.disabled;
    }

    function update() {
      if (window.innerWidth > 749) {
        bar.classList.remove('is-visible');
        return;
      }
      var rect = original.getBoundingClientRect();
      var show = rect.bottom < 0 && !original.disabled;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (button) button.addEventListener('click', function () { if (!original.disabled) original.click(); });
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () { sync(); update(); });
      observer.observe(original, { attributes: true, childList: true, subtree: true });
      if (originalPrice) observer.observe(originalPrice, { childList: true, subtree: true, characterData: true });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    sync();
    update();
  }

  function initCollectionDescriptions() {
    document.querySelectorAll('.template-collection .rte--header').forEach(function (description) {
      if (description.scrollHeight < 145) return;
      description.classList.add('is-collapsible');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ldo-description-toggle';
      button.textContent = 'Read full description';
      button.setAttribute('aria-expanded', 'false');
      description.insertAdjacentElement('afterend', button);
      button.addEventListener('click', function () {
        var expanded = description.classList.toggle('is-expanded');
        button.textContent = expanded ? 'Show less' : 'Read full description';
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }


  function initBrandCarousels() {
    document.querySelectorAll('.ldo-brands').forEach(function (section) {
      var track = section.querySelector('[data-ldo-carousel]');
      if (!track) return;
      var prev = section.querySelector('[data-ldo-carousel-prev]');
      var next = section.querySelector('[data-ldo-carousel-next]');

      function cardWidth() {
        var first = track.querySelector('.ldo-brand-card');
        if (!first) return Math.max(track.clientWidth * 0.85, 200);
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 10) || 10;
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        if (!prev || !next) return;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      function scrollByAmount(direction) {
        track.scrollBy({ left: direction * cardWidth() * 2.5, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
      if (next) next.addEventListener('click', function () { scrollByAmount(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }



  function initProductCarousels() {
    document.querySelectorAll('[data-ldo-product-carousel]').forEach(function (section) {
      var track = section.querySelector('[data-ldo-product-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ldo-product-card]'));
      if (cards.length < 2) return;
      var prev = section.querySelector('[data-ldo-product-prev]');
      var next = section.querySelector('[data-ldo-product-next]');
      var mode = section.getAttribute('data-rotation-mode') || 'none';
      var sectionId = section.getAttribute('data-section-id') || '';
      var designMode = !!(window.Shopify && window.Shopify.designMode);

      function stableHash(value) {
        var hash = 0;
        for (var i = 0; i < value.length; i++) hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0;
        return Math.abs(hash);
      }

      // Keep the curated pool fresh, but stable for the whole day.
      if (mode === 'daily' && cards.length > 1 && !designMode) {
        var dayNumber = Math.floor(Date.now() / 86400000);
        var offset = (dayNumber + stableHash(sectionId)) % cards.length;
        for (var i = 0; i < offset; i++) track.appendChild(cards[i]);
        cards = Array.prototype.slice.call(track.querySelectorAll('[data-ldo-product-card]'));
      }

      function pageAmount() {
        return Math.max(track.clientWidth * 0.92, 240);
      }

      // In the theme editor, avoid cloned Shopify blocks; arrows still wrap.
      if (designMode) {
        if (prev) prev.addEventListener('click', function () {
          if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: 'auto' });
          track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          var max = Math.max(0, track.scrollWidth - track.clientWidth - 4);
          if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'auto' });
          track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
        });
        return;
      }

      function cloneCard(card) {
        var clone = card.cloneNode(true);
        clone.removeAttribute('data-ldo-product-card');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-ldo-carousel-clone', 'true');
        clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
        return clone;
      }

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      cards.forEach(function (card) {
        before.appendChild(cloneCard(card));
        after.appendChild(cloneCard(card));
      });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      track.classList.add('is-infinite');

      var sequenceWidth = 0;
      var normalizeTimer = null;
      var restoringBehavior = null;

      function measure() {
        var originals = Array.prototype.slice.call(track.querySelectorAll('[data-ldo-product-card]'));
        var clones = Array.prototype.slice.call(track.querySelectorAll('[data-ldo-carousel-clone]'));
        if (!originals.length || !clones.length) return;
        sequenceWidth = originals[0].offsetLeft - clones[0].offsetLeft;
      }

      function jumpTo(left) {
        var oldBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        window.cancelAnimationFrame(restoringBehavior);
        restoringBehavior = window.requestAnimationFrame(function () {
          track.style.scrollBehavior = oldBehavior;
        });
      }

      function normalize() {
        if (!sequenceWidth) measure();
        if (!sequenceWidth) return;
        // Middle copy begins at sequenceWidth. Crossing into the next copy is
        // visually identical to returning to the same point in the middle copy.
        while (track.scrollLeft >= sequenceWidth * 2 - 2) jumpTo(track.scrollLeft - sequenceWidth);
        while (track.scrollLeft < sequenceWidth - 2) jumpTo(track.scrollLeft + sequenceWidth);
      }

      function scheduleNormalize() {
        window.clearTimeout(normalizeTimer);
        normalizeTimer = window.setTimeout(normalize, 90);
      }

      function startInMiddle() {
        measure();
        if (sequenceWidth) jumpTo(sequenceWidth);
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
        scheduleNormalize();
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
        scheduleNormalize();
      });

      track.addEventListener('scroll', scheduleNormalize, { passive: true });
      if ('onscrollend' in window) track.addEventListener('scrollend', normalize, { passive: true });
      window.addEventListener('resize', function () {
        var ratio = sequenceWidth ? (track.scrollLeft % sequenceWidth) / sequenceWidth : 0;
        measure();
        if (sequenceWidth) jumpTo(sequenceWidth + ratio * sequenceWidth);
      });

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(startInMiddle);
      });
    });
  }

  function initRecentlyViewed() {
    var storageKey = 'ldoRecentlyViewedProductsV2';
    var currentNode = document.querySelector('[data-ldo-current-product]');
    var current = null;
    var items = [];

    try {
      items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(items)) items = [];
    } catch (e) { items = []; }

    if (currentNode) {
      try { current = JSON.parse(currentNode.textContent); } catch (e) { current = null; }
    }

    document.querySelectorAll('[data-ldo-recently-viewed]').forEach(function (section) {
      var grid = section.querySelector('[data-ldo-recent-grid]');
      if (!grid) return;
      var visible = items.filter(function (item) {
        return item && item.url && (!current || item.url !== current.url);
      }).slice(0, 4);
      if (!visible.length) return;

      grid.innerHTML = visible.map(function (item) {
        var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '';
        var vendor = item.vendor ? '<span class="ldo-recent-card__vendor">' + escapeHtml(item.vendor) + '</span>' : '';
        return '<a class="ldo-recent-card" href="' + escapeHtml(item.url) + '">' + image + vendor + '<strong>' + escapeHtml(item.title) + '</strong><span class="ldo-recent-card__price">' + escapeHtml(item.price) + '</span></a>';
      }).join('');
      section.hidden = false;
    });

    if (current && current.url) {
      items = items.filter(function (item) { return item && item.url !== current.url; });
      items.unshift(current);
      try { localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 8))); } catch (e) {}
    }
  }

  ready(function () {
    initMobileATC();
    initCollectionDescriptions();
    initBrandCarousels();
    initProductCarousels();
    initRecentlyViewed();
  });
})();
